/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { createTheme } from '@mui/material/styles';

const createAppTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#7aa2ff" : "#2f6bff",
        contrastText: "#fff",
      },
      secondary: {
        main: mode === "dark" ? "#b28fef" : "#C2A0A0",
        contrastText: "#fff",
      },
      background: {
        default: mode === "dark" ? "#07111f" : "#f7fbff",
        paper: mode === "dark" ? "#0f172a" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#f3f7ff" : "#3a3a3a",
        secondary: mode === "dark" ? "#8fa4c2" : "#6a7280",
      },
    },
    typography: {
      fontFamily: 'Sora, "Segoe UI", sans-serif',
      button: {
        textTransform: "none",
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "0.7rem",
          },
        },
      },
    },
  });

export default createAppTheme;